module.exports = __webpack_public_path__ + "static/media/gallery2.c0312236.jpg";